const isProduction =
	Shopify.shop.toLowerCase().includes('sandbox') || Shopify.shop.toLowerCase().includes('vevol')
		? false
		: Shopify.theme.role === 'main'
		? true
		: false;
const API_URL = isProduction
	? 'https://blackstone-bookshelf.gadget.app'
	: Shopify.shop.toLowerCase().includes('vevol')
	? 'https://blackstone-bookshelf--vevol-dev.gadget.app'
	: 'https://blackstone-bookshelf--dev.gadget.app';
const PLAYER_URL = isProduction
	? 'https://my.blackstoneunlimited.com'
	: window.themeVariables.player.playerDevUrl
	? window.themeVariables.player.playerDevUrl.trim()
	: 'https://my.blackstoneunlimited.com';

console.log('Current environment:', isProduction ? 'Production' : 'Development');

window.API_URL = API_URL;

// Reset ApiToken cookie if the user is not logged in
const checkCookie = (name) => {
	if (!ShopifyAnalytics.meta.page.customerId) {
		document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
	}
};

checkCookie('gadget_shopify_link');

// This function will check if the user has a cookie with the token
// If not, it will fetch the token from the server and save it to cookies
// The token will be used to authenticate the user with the API
window.getApiToken = async (customerId) => {
	// Check if the token exists in cookies
	const existingToken = getCookie('gadget_shopify_link');

	if (existingToken) {
		return existingToken;
	}

	// If not found in cookies, fetch from server
	const response = await fetch(`${API_URL}/browser/generate-token`, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ customerId }),
	});

	const data = await response.json();
	const token = data.token;

	// Save the token to cookies with 30-day expiration
	setCookie('gadget_shopify_link', token, 30);

	return token;
};

// Helper function to get a cookie by name
const getCookie = (name) => {
	const cookies = document.cookie.split(';');

	for (let cookie of cookies) {
		const [cookieName, cookieValue] = cookie.trim().split('=');

		if (cookieName === name) {
			return cookieValue;
		}
	}
	return null;
};

window.deleteCookie = (name) => {
	document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
};

// Helper function to set a cookie with expiration
const setCookie = (name, value, daysToExpire) => {
	// set a cookie with the name, value, and expiration date
	const date = new Date();
	date.setTime(date.getTime() + daysToExpire * 24 * 60 * 60 * 1000);
	document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
};

const getBookshelfMarkup = async (sectionId, queries, loadingStarted = false) => {
	const MyLibrary = document.querySelector('my-library');
	const maxLoad = parseInt(MyLibrary.dataset.max);
	const bookshelfContainerSelector = '.bookshelf-data-container';

	if (sectionId === 'my-library-products' && !loadingStarted) {
		triggerEvent(document.documentElement, 'theme:loading:start');
		document.querySelector(bookshelfContainerSelector).classList.add('disabled');
	}

	try {
		const response = await fetch(`${window.themeVariables.routes.rootUrlWithoutSlash}/?section_id=${sectionId}&max=${maxLoad}&${queries}`, {
			cache: 'reload',
		});

		if (response.ok) {
			const responseString = await response.text();
			const parser = new DOMParser();
			const responseMarkup = parser.parseFromString(responseString, 'text/html');
			const bookshelfContainer = document.querySelector(bookshelfContainerSelector);

			if (sectionId === 'my-library-products') {
				const updatedContent = responseMarkup.querySelector(bookshelfContainerSelector);
				const totalResults = parseInt(responseMarkup.querySelector('.product-list__inner')?.dataset.totalResults || 0);

				// console.log('Last query:', MyLibrary.dataset.lastQuery);

				bookshelfContainer.innerHTML = updatedContent.innerHTML;
				MyLibrary.dataset.lastQuery = queries;

				toggleShowButtons(totalResults);
			}

			return responseMarkup;
		} else {
			console.error('Promise resolved but HTTP status failed');
		}
	} catch {
		console.error('Promise rejected');
	} finally {
		if (sectionId === 'my-library-products') {
			document.querySelector('.bookshelf-data-container').classList.remove('disabled');
			triggerEvent(document.documentElement, 'theme:loading:end');
		}
	}
};

const removeBookFromLibrary = async (customerId, bookId, isLibraryPage = true) => {
	const url = `${API_URL}/browser/bookshelf/delete-books`;
	const currentQuery = isLibraryPage ? document?.querySelector('my-library')?.dataset?.lastQuery : '';
	const requestBody = {
		skus: [bookId],
	};
	const gadgetToken = await window.getApiToken(customerId);

	triggerEvent(document.documentElement, 'theme:loading:start');

	if (isLibraryPage) {
		document.querySelector('.bookshelf-data-container').classList.add('disabled');
	}

	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${gadgetToken}`,
			},
			body: JSON.stringify(requestBody),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.error}`);
		}

		const responseData = await response.json();

		if (isLibraryPage && currentQuery) {
			getBookshelfMarkup('my-library-products', currentQuery, true);
			getBookshelfMarkup('my-library-filters', currentQuery);
		} else {
			document.querySelector('.bookshelf-data-container')
				? document.querySelector('.bookshelf-data-container').classList.remove('disabled')
				: '';
			triggerEvent(document.documentElement, 'theme:loading:end', { bookId });
		}

		return responseData;
	} catch (error) {
		console.error('Failed to remove book:', error);

		throw new Error('An error occurred while removing the book. Please try again later.');
	}
};

const updateBookStatus = async (customerId, bookId, status, isLibraryPage = true) => {
	const url = `${API_URL}/browser/bookshelf/update-book`;
	const currentQuery = isLibraryPage ? document.querySelector('my-library')?.dataset?.lastQuery : '';
	const requestBody = {
		sku: bookId,
		status,
	};

	const gadgetToken = await window.getApiToken(customerId);

	triggerEvent(document.documentElement, 'theme:loading:start');

	if (isLibraryPage) {
		document.querySelector('.bookshelf-data-container').classList.add('disabled');
	}

	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${gadgetToken}`,
			},
			body: JSON.stringify(requestBody),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.error}`);
		}

		const responseData = await response.json();

		if (isLibraryPage && currentQuery) {
			getBookshelfMarkup('my-library-products', currentQuery, true);
			getBookshelfMarkup('my-library-filters', currentQuery);
		} else {
			document.querySelector('.bookshelf-data-container').classList.remove('disabled');
			triggerEvent(document.documentElement, 'theme:loading:end', { status, bookId });
		}

		return responseData;
	} catch (error) {
		console.error('Failed to remove book:', error);

		throw new Error('An error occurred while removing the book. Please try again later.');
	}
};

const addBookToLibrary = async (customerId, bookId, variantSku, isLibraryPage = false) => {
	const url = `${API_URL}/browser/bookshelf/add-book`;
	const currentQuery = isLibraryPage ? document.querySelector('my-library').dataset.lastQuery : '';
	const gadgetToken = await window.getApiToken(customerId);

	const requestBody = {
		sku: bookId,
		variantSku: variantSku,
	};

	triggerEvent(document.documentElement, 'theme:loading:start');

	if (isLibraryPage) {
		document.querySelector('.bookshelf-data-container').classList.add('disabled');
	}

	try {
		const response = await fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${gadgetToken}`,
			},
			body: JSON.stringify(requestBody),
		});

		if (!response.ok) {
			throw new Error(`Error: ${response.error}`);
		}

		// 🔹 Read the response stream (Prevents browser from hanging the loading bar)
		const reader = response.body.getReader();
		let decoder = new TextDecoder();
		let result = '';

		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			result += decoder.decode(value, { stream: true });
		}

		const responseData = JSON.parse(result);

		if (isLibraryPage) {
			getBookshelfMarkup('my-library-products', currentQuery, true);
			getBookshelfMarkup('my-library-filters', currentQuery);
		}

		return responseData;
	} catch (error) {
		console.error('Failed to add book:', error);

		throw new Error('An error occurred while adding the book. Please try again later.');
	}
};

// This function is not currently used and will be updated to use the new endpoints:
// /bookshelf/customer-books for a slim version
// /account/library for a full version
const getBookshelfData = async (customerId) => {
	const url = `${API_URL}/get-data?customer=${customerId}`;

	try {
		const response = await fetch(url);

		if (!response.ok) {
			throw new Error(`Error: ${response.statusText}`);
		}

		const responseData = await response.json();

		return responseData;
	} catch (error) {
		console.error('Failed to get bookshelf data:', error);

		throw new Error('An error occurred while getting the bookshelf data. Please try again later.');
	}
};

if (typeof QuickBuyDrawerContentLibrary != 'function') {
	class QuickBuyDrawerContentLibrary extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				playButton: '[data-play-button]',
				returnButton: '[data-return-button]',
				markAsNewButton: '[data-mark-new-button]',
				markAsFinishedButton: '[data-mark-finish-button]',
			};

			this.elements = {
				playButton: this.querySelector(this.selectors.playButton),
				returnButton: this.querySelector(this.selectors.returnButton),
				markAsNewButton: this.querySelector(this.selectors.markAsNewButton),
				markAsFinishedButton: this.querySelector(this.selectors.markAsFinishedButton),
			};

			this.bookId = this.getAttribute('data-book-id');
			this.customerId = this.getAttribute('data-customer-id');
			this.productHandle = this.getAttribute('data-product-handle');

			// Uncomment when the refetching is needed
			// this.refetchInterval = null; // Store the interval ID
			// this.refetchIntervalTime = window.themeVariables.player.playerVerticalAlignment ? parseInt(window.themeVariables.player.playerVerticalAlignment) * 1000 : 15000;
		}

		connectedCallback() {
			this.addListeners();
		}

		addListeners() {
			this.addEventListener('click', (event) => {
				if (event.target.closest(this.selectors.playButton)) {
					const button = event.target.closest(this.selectors.playButton);

					this.playBook();
					// this.reFetchCustomerMetafieldsForBook();
				}

				if (event.target.closest(this.selectors.returnButton)) {
					this.returnBook();
				}

				if (event.target.closest(this.selectors.markAsNewButton)) {
					this.updateStatusBook('new');
				}

				if (event.target.closest(this.selectors.markAsFinishedButton)) {
					this.updateStatusBook('finished');
				}
			});

			this.addEventListener('close::drawer', () => {
				// this.stopRefetching();
			});
		}

		playBook() {
			const windowName = 'windowPlayer';
			let width = window.themeVariables.player.playerWidthDesktop || 600;
			let height = window.themeVariables.player.playerHeightDesktop || 600;
			const urlToPlay = `${PLAYER_URL}/${this.bookId}`;
			const playerAlignmentX = window.themeVariables.player.playerHorizontalAlignment || 0;
			const playerAlignmentY = window.themeVariables.player.playerVerticalAlignment || 0;

			if (window.innerWidth < 768) {
				const getFullWV = window.innerWidth;
				const getFullHV = window.innerHeight;

				const pvBasedOnWV = (getFullWV * window.themeVariables.player.playerWidthMobile) / 100;
				const pvBasedOnHV = (getFullHV * window.themeVariables.player.playerHeightMobile) / 100;

				width = pvBasedOnWV;
				height = pvBasedOnHV;
			}

			let left = screen.width - width;
			let top = screen.height - height;

			if (window.innerWidth > 768) {
				left = (playerAlignmentX / 100) * screen.width - width / 2;
				top = (playerAlignmentY / 100) * screen.height - height / 2;
			}

			const features = `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=no,scrollbars=no`;

			window.open(urlToPlay, windowName, features);
		}

		// reFetchCustomerMetafieldsForBook() {
		//     // If there's already an interval running, clear it before starting a new one
		//     if (this.refetchInterval) {
		//         clearInterval(this.refetchInterval);
		//     }

		//     this.refetchInterval = setInterval(async () => {
		// 		try {
		// 			const response = await fetch(`/products/${this.productHandle}?section_id=my-library-play-button`);

		// 			if (response.ok) {
		// 				const data = await response.text();

		// 				if (data) {
		// 					const parser = new DOMParser();
		// 					const responseMarkup = parser.parseFromString(data, 'text/html');
		// 					const playButton = responseMarkup.querySelector(this.selectors.playButton);

		// 					if (playButton) {
		// 						this.elements.playButton.outerHTML = playButton.outerHTML;
		// 					} else {
		// 						console.error('Play button not found in the response');
		// 					}
		// 				}
		// 			} else {
		// 				console.error('Promise resolved but HTTP status failed');
		// 			}
		// 		} catch {
		// 			console.error('Promise rejected');
		// 		}
		//     }, this.refetchIntervalTime); // 20 seconds interval
		// }

		// stopRefetching() {
		//     if (this.refetchInterval) {
		//         clearInterval(this.refetchInterval);
		//         this.refetchInterval = null;
		//         console.log('Stopped refetching due to drawer close');
		//     }
		// }

		returnBook() {
			removeBookFromLibrary(this.customerId, this.bookId).then(() => {
				document.querySelector('.drawer--library').open = false;
				// this.stopRefetching();
			});
		}

		updateStatusBook(status) {
			updateBookStatus(this.customerId, this.bookId, status).then(() => {
				document.querySelector('.drawer--library').open = false;
				// this.stopRefetching();
			});
		}
	}

	if (typeof customElements.get('quick-buy-drawer-library') == 'undefined') {
		customElements.define('quick-buy-drawer-library', QuickBuyDrawerContentLibrary);
	}
}

var OpenableBox = class extends OpenableElement {
	constructor() {
		super();

		this.addListeners();
	}

	addListeners() {
		this.addEventListener('click', (event) => {
			if (event.target.getAttribute('data-action') == 'return-ebook') {
				this.returnBook();
			}

			if (event.target.getAttribute('data-action') == 'finish-ebook') {
				this.updateBook('finished');
			}

			if (event.target.getAttribute('data-action') == 'new-ebook') {
				this.updateBook('new');
			}
		});
	}

	returnBook() {
		const productItem = this.closest('product-item');
		const bookId = productItem.getAttribute('data-book-id');
		const customerId = productItem.getAttribute('data-customer-id');

		removeBookFromLibrary(customerId, bookId).then(() => {
			const currentQuery = document.querySelector('my-library')?.dataset?.lastQuery;

			if (currentQuery) {
				getBookshelfMarkup('my-library-products', currentQuery);
				getBookshelfMarkup('my-library-filters', currentQuery);
			} else {
				document.querySelector('.bookshelf-data-container').classList.remove('disabled');
				triggerEvent(document.documentElement, 'theme:loading:end');
			}
		});
	}

	updateBook(status) {
		const productItem = this.closest('product-item');
		const bookId = productItem.getAttribute('data-book-id');
		const customerId = productItem.getAttribute('data-customer-id');

		updateBookStatus(customerId, bookId, status).then(() => {
			const currentQuery = document.querySelector('my-library')?.dataset?.lastQuery;

			if (currentQuery) {
				getBookshelfMarkup('my-library-products', currentQuery);
				getBookshelfMarkup('my-library-filters', currentQuery);
			} else {
				document.querySelector('.bookshelf-data-container').classList.remove('disabled');
				triggerEvent(document.documentElement, 'theme:loading:end');
			}
		});
	}

	connectedCallback() {
		super.connectedCallback();

		this.buttonReference = document.querySelector(`[aria-controls="${this.id}"]`);
		this.addEventListener('openable-element:open', this.openSVG.bind(this));
		this.addEventListener('openable-element:close', this.closeSVG.bind(this));
	}

	openSVG() {
		if (!this.buttonReference) return;

		this.buttonReference.querySelector('.icon--dots').classList.add('is-hidden');
		this.buttonReference.querySelector('.icon--close').classList.remove('is-hidden');
	}

	closeSVG() {
		if (!this.buttonReference) return;

		this.buttonReference.querySelector('.icon--dots').classList.remove('is-hidden');
		this.buttonReference.querySelector('.icon--close').classList.add('is-hidden');
	}
};

window.customElements.define('quick-actions-drawer', OpenableBox);

if (typeof BookshelfProductBlock != 'function') {
	class BookshelfProductBlock extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				playButton: '[data-action="play-book"]',
				returnButton: '[data-action="return-book"]',
				addButton: '[data-action="add-book"]',
			};

			this.currentBookData = this.querySelector('[data-current-book]').textContent;
			this.currentBookData = JSON.parse(this.currentBookData);
			this.bookId = this.getAttribute('book-id');
			this.variantSku = this.getAttribute('data-variant-sku');
			this.customerId = this.getAttribute('customer-id');
			this.productHandle = this.getAttribute('data-product-handle');

			// Uncomment when the refetching is needed
			// this.refetchInterval = null; // Store the interval ID
			// this.refetchIntervalTime = window.themeVariables.player.playerVerticalAlignment ? parseInt(window.themeVariables.player.playerVerticalAlignment) * 1000 : 15000;
		}

		connectedCallback() {
			this.addListeners();
		}

		addListeners() {
			this.addEventListener('click', (event) => {
				if (event.target.closest(this.selectors.playButton)) {
					const button = event.target.closest(this.selectors.playButton);

					this.playBook();
					// this.reFetchCustomerMetafieldsForBook();
				}

				if (event.target.closest(this.selectors.returnButton)) {
					this.returnBook(event.target.closest('button'));
				}

				if (event.target.closest(this.selectors.addButton)) {
					this.addBook(event.target.closest('button'));
				}
			});

			this.addEventListener('close::drawer', () => {
				// this.stopRefetching();
			});
		}

		playBook(track, elapsedTime) {
			const windowName = 'windowPlayer';
			let width = window.themeVariables.player.playerWidthDesktop || 600;
			let height = window.themeVariables.player.playerHeightDesktop || 600;
			const urlToPlay = `${PLAYER_URL}/${this.currentBookData.bookId}`;

			if (window.innerWidth < 768) {
				const getFullWV = window.innerWidth;
				const getFullHV = window.innerHeight;

				const pvBasedOnWV = (getFullWV * window.themeVariables.player.playerWidthMobile) / 100;
				const pvBasedOnHV = (getFullHV * window.themeVariables.player.playerHeightMobile) / 100;

				width = pvBasedOnWV;
				height = pvBasedOnHV;
			}

			let left = screen.width - width;
			const top = screen.height - height;

			if (window.innerWidth > 768) {
				left = screen.width - width - (window.themeVariables.player.playerHorizontalAlignment / 100) * screen.width;
			}

			const features = `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no,resizable=no,scrollbars=no`;

			window.open(urlToPlay, windowName, features);
		}

		returnBook(button) {
			const parent = this;

			button._startTransition();

			removeBookFromLibrary(this.customerId, this.bookId, false).then(() => {
				// this.stopRefetching();
				parent.classList.remove('included');
				button._endTransition();

				// Trigger the event to update the play button
				triggerEvent(document.documentElement, 'book-returned', { bookId: this.bookId, variantSku: this.variantSku });
			});
		}

		addBook(button) {
			const parent = this;

			button._startTransition();

			addBookToLibrary(this.customerId, this.bookId, this.variantSku, false).then(() => {
				parent.classList.add('included');
				button._endTransition();

				// Trigger the event to update the play button
				triggerEvent(document.documentElement, 'book-added', { bookId: this.bookId, variantSku: this.variantSku });
			});
		}

		// reFetchCustomerMetafieldsForBook() {
		//     // If there's already an interval running, clear it before starting a new one
		//     if (this.refetchInterval) {
		//         clearInterval(this.refetchInterval);
		//     }

		//     this.refetchInterval = setInterval(async () => {
		// 		try {
		// 			const response = await fetch(`/products/${this.productHandle}?section_id=my-library-play-button`);

		// 			if (response.ok) {
		// 				const data = await response.text();

		// 				if (data) {
		// 					const parser = new DOMParser();
		// 					const responseMarkup = parser.parseFromString(data, 'text/html');
		// 					const playButton = responseMarkup.querySelector(this.selectors.playButton);

		// 					if (playButton) {
		// 						this.querySelector(this.selectors.playButton).outerHTML = playButton.outerHTML;
		// 					} else {
		// 						console.error('Play button not found in the response');
		// 					}
		// 				}
		// 			} else {
		// 				console.error('Promise resolved but HTTP status failed');
		// 			}
		// 		} catch {
		// 			console.error('Promise rejected');
		// 		}
		//     }, this.refetchIntervalTime); // 20 seconds interval
		// }

		// stopRefetching() {
		//     if (this.refetchInterval) {
		//         clearInterval(this.refetchInterval);
		//         this.refetchInterval = null;
		//         console.log('Stopped refetching due to drawer close');
		//     }
		// }
	}

	if (typeof customElements.get('bookshelf-product-block') == 'undefined') {
		customElements.define('bookshelf-product-block', BookshelfProductBlock);
	}
}

if (typeof LibraryForm !== 'function') {
	class LibraryForm extends HTMLElement {
		constructor() {
			super();

			this.classes = {
				hidden: 'is-hidden',
			};

			this.selectors = {
				step: (step) => `[data-step="${step}"]`,
				steps: '[data-step]',
				dropDownSelect: '.input__dropdown-select',
				dropDownSelectList: '.input__dropdown-select-list',
				dropDownSelectItem: '.dropdown-item',
			};

			this.elements = {
				steps: this.querySelectorAll(this.selectors.steps),
			};

			// this.searchedLibrary = sessionStorage.getItem('libraryData') ? JSON.parse(sessionStorage.getItem('libraryData')).searchedLibrary : null;
			this.currentStep = this.getAttribute('data-current-step') || 1;
			this.stepsObjects = {};
			this.libraryData = {};
			this.customerId = this.getAttribute('data-customer-id') || null;
			this.allLibraries = [];
			this.init();
		}

		async init() {
			if (this.customerId) {
				this.elements.steps.forEach((step) => this.initStep(step));
				this.changeStep();
				await this.getAllLibraries();
			} else {
				console.error('Customer ID is required');
			}
		}

		changeStep() {
			this.elements.steps.forEach((step) => step.classList.add(this.classes.hidden));
			this.querySelector(this.selectors.step(this.currentStep)).classList.remove(this.classes.hidden);
		}

		initSelect() {
			const input = this.stepsObjects[1].parent.querySelector('#libraryIdentifier');
			const select = this.stepsObjects[1].parent.querySelector(this.selectors.dropDownSelect);
			const selectList = this.stepsObjects[1].parent.querySelector(this.selectors.dropDownSelectList);

			this.allLibraries.forEach((library) => {
				const item = document.createElement('li');
				item.classList.add('dropdown-item');
				item.setAttribute('data-name', library.customName ? library.customName : library.name);
				item.setAttribute('data-zip', library.contactZip ? library.contactZip : '');
				item.innerHTML = `<span>${library.customName ? library.customName : library.name}</span> <span>${
					library.contactZip ? library.contactZip : ''
				}<span>`;
				selectList.appendChild(item);
			});

			selectList.addEventListener('click', (e) => {
				if (e.target.classList.contains('dropdown-item')) {
					this.stepsObjects[1].parent.querySelector('#libraryIdentifier').value = e.target.getAttribute('data-name');
					select.classList.add(this.classes.hidden);
				}
			});

			input.addEventListener(
				'input',
				this.debounce((e) => {
					const selectItems = selectList.querySelectorAll(this.selectors.dropDownSelectItem);
					const value = e.target.value;

					if (!value || value.trim() === '') {
						select.classList.add(this.classes.hidden);
					} else {
						let libraryFound = false;
						select.classList.remove(this.classes.hidden);

						selectItems.forEach((item) => {
							const libraryName = item.getAttribute('data-name') ? item.getAttribute('data-name').toLowerCase().trim() : '';
							const libraryZip = item.getAttribute('data-zip') ? item.getAttribute('data-zip').toLowerCase().trim() : '';

							if (libraryName.includes(value.toLowerCase().trim()) || libraryZip.includes(value.toLowerCase().trim())) {
								item.classList.remove(this.classes.hidden);
								libraryFound = true;
							} else {
								item.classList.add(this.classes.hidden);
							}
						});

						if (!libraryFound) {
							selectList.querySelector('[data-no-result]').classList.remove(this.classes.hidden);
						} else {
							selectList.querySelector('[data-no-result]').classList.add(this.classes.hidden);
						}
					}
				}, 600)
			);
		}

		debounce(fn, delay) {
			let timer = null;

			return (...args) => {
				clearTimeout(timer);

				timer = setTimeout(() => {
					fn.apply(this, args);
				}, delay);
			};
		}

		initStep(step) {
			const stepNumber = step.getAttribute('data-step');
			const stepInputs = step.querySelectorAll('input');
			const stepButton = step.querySelector('button');
			const stepError = step.querySelector('.banner--error');

			if (this.searchedLibrary && stepNumber === '1') {
				stepInputs.forEach((input) => {
					if (input.id === 'libraryIdentifier') {
						input.value = this.searchedLibrary;
						input.focus();
						input.click();
					}
				});
			}

			if (stepButton) {
				stepButton.addEventListener('click', async (e) => {
					if (this.validateStep(e, stepNumber)) {
						const response = await this.stepAction();

						if (response.status === 'ok') {
							this.currentStep = parseInt(stepNumber) + 1;
							this.changeStep();
						} else {
							this.stepsObjects[this.currentStep].error.classList.remove(this.classes.hidden);
							this.stepsObjects[this.currentStep].error.querySelector('p').innerText = response.error;
						}
					}
				});
			}

			this.stepsObjects[stepNumber] = {
				inputs: stepInputs,
				button: stepButton,
				error: stepError,
				parent: step,
			};
		}

		validateStep(e, stepNumber) {
			e.preventDefault();

			const step = this.stepsObjects[stepNumber];
			let isValid = true;

			step.inputs.forEach((input) => {
				if (input.parentElement.classList.contains('is-hidden')) return;

				if (!input.value || input.value.trim() === '') {
					isValid = false;
					input.classList.add('is-danger');
				} else {
					input.classList.remove('is-danger');
				}
			});

			if (isValid) {
				step.error.classList.add(this.classes.hidden);
				return true;
			} else {
				step.error.classList.remove(this.classes.hidden);
				return false;
			}
		}

		async stepAction() {
			let resp;

			if (this.currentStep == 1) {
				resp = await this.checkLibraryList();
			} else if (this.currentStep == 2) {
				resp = await this.loginWithCredentials();
			}

			return resp;
		}

		async checkLibraryList() {
			this.initLoading();
			const gadgetToken = await window.getApiToken(this.customerId);

			const libraryIdBasedOnInputName = this.allLibraries.find(
				(el) =>
					(el.customName &&
						el.customName.toLowerCase().trim() === this.stepsObjects[this.currentStep].inputs[0].value.toLowerCase().trim()) ||
					(el.name && el.name.toLowerCase().trim() === this.stepsObjects[this.currentStep].inputs[0].value.toLowerCase().trim())
			);

			if (!libraryIdBasedOnInputName) {
				return {
					status: 'error',
					error: 'We do not recognize your library, please reach out to your library for more information, or call Blackstone Library at 1-800-621-0182.',
				};
			}

			this.removeLoading();

			this.libraryData = libraryIdBasedOnInputName;
			// sessionStorage.setItem('libraryData', JSON.stringify({ searchedLibrary: this.stepsObjects[this.currentStep].inputs[0].value }));

			if (this.libraryData.enabled) {
				this.stepsObjects[2].inputs.forEach((input) => {
					if (input.id === 'libraryCardNumber') {
						if (['none', 'pin'].includes(libraryIdBasedOnInputName.requiresValidation)) {
							input.parentElement.classList.add(this.classes.hidden);
						} else {
							input.parentElement.classList.remove(this.classes.hidden);
						}
					}

					if (input.id === 'libraryCardPin') {
						if (['none', 'code'].includes(libraryIdBasedOnInputName.requiresValidation)) {
							input.parentElement.classList.add(this.classes.hidden);
						} else {
							input.parentElement.classList.remove(this.classes.hidden);
						}
					}
				});

				return {
					status: 'ok',
					data: {
						library: this.stepsObjects[this.currentStep].inputs[0].value,
					},
				};
			} else {
				return {
					status: 'error',
					error: 'Your library is no longer available on our website, please reach out to your library for more information, or call Blackstone Library at 1-800-621-0182.',
				};
			}
		}

		async loginWithCredentials() {
			const firstNameAttr = this.dataset.customerFirstName;
			const lastNameAttr = this.dataset.customerLastName;

			const cardNumber = this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardNumber').value.trim();
			const cardNumberToBeChecked = !this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardNumber').parentElement.classList.contains('is-hidden');

			const cardPin = this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardPin').value.trim();
			const cardPinToBeChecked = !this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardPin').parentElement.classList.contains('is-hidden');

			const customerFirstName = this.stepsObjects[this.currentStep]?.parent?.querySelector('#customer\\[first_name\\]')?.value?.trim();
			const customerLastName = this.stepsObjects[this.currentStep]?.parent?.querySelector('#customer\\[last_name\\]')?.value?.trim();

			if (
				cardNumberToBeChecked && cardNumber === '' ||
				cardPinToBeChecked && cardPin === '' ||
				!this.customerId ||
				!this.libraryData.id ||
				(!firstNameAttr && !customerFirstName) ||
				(!lastNameAttr && !customerLastName)
			) {
				return {
					status: 'error',
					error: 'Please fill in all the fields',
				};
			}

			const body = {
				libraryId: this.libraryData.id,
				customerFirstName: !firstNameAttr ? customerFirstName : 'customer_first_name_existent',
				customerLastName: !lastNameAttr ? customerLastName : 'customer_last_name_existent',
				cardNumber: this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardNumber').value.trim(),
				pinNumber: this.stepsObjects[this.currentStep].parent.querySelector('#libraryCardPin').value.trim(),
			};

			if (this.hasAttribute('data-bps')) {
				body.bps = this.getAttribute('data-bps') === 'true';
			}

			this.initLoading();

			const gadgetToken = await window.getApiToken(this.customerId);

			const response = await fetch(`${API_URL}/browser/validate`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${gadgetToken}`,
				},
				body: JSON.stringify(body),
			});

			const data = await response.json();

			this.removeLoading();

			if (data.error || (data.message && data.message.toLowerCase().includes('unauthorized'))) {
				console.log('error', data);
				return {
					status: 'error',
					error: `Some error occured${
						data.error ? `: ${data.error}` : ''
					}. Please reach out to your library for more information, or call Blackstone Library at 1-800-621-0182.`,
				};
			} else {
				return {
					status: 'ok',
				};
			}
		}

		initLoading() {
			this.stepsObjects[this.currentStep].button.setAttribute('aria-busy', 'true');
			this.stepsObjects[this.currentStep].inputs.forEach((input) => input.setAttribute('disabled', 'disabled'));
		}

		removeLoading() {
			this.stepsObjects[this.currentStep].button.removeAttribute('aria-busy');
			this.stepsObjects[this.currentStep].inputs.forEach((input) => input.removeAttribute('disabled'));
		}

		async getAllLibraries() {
			// Disable input and button initially
			const libraryInput = this.stepsObjects[1].inputs[0];
			const submitButton = this.stepsObjects[1].button;
			libraryInput.setAttribute('disabled', 'disabled');
			submitButton.setAttribute('disabled', 'disabled');

			let gadgetToken = await window.getApiToken(this.customerId);

			if (!gadgetToken || gadgetToken === 'undefined') {
				window.deleteCookie('gadget_shopify_link');

				gadgetToken = await window.getApiToken(this.customerId);
			}

			if (!gadgetToken || gadgetToken === 'undefined') {
				const initialErrorMessage = `An error occurred while fetching the libraries. Please try again later or contact support. <br> If you just created an account, please retry in a few minutes.`;
				this.stepsObjects[1].error.querySelector('p').innerHTML = initialErrorMessage;
				this.stepsObjects[1].error.classList.remove(this.classes.hidden);
				this.stepsObjects[1].button.classList.add(this.classes.hidden);
				this.stepsObjects[1].inputs.forEach((input) => input.parentElement.classList.add(this.classes.hidden));
			} else {
				fetch(`${API_URL}/browser/libraries`, {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${gadgetToken}`,
					},
				})
					.then((response) => response.json())
					.then((resp) => {
						if (resp.error || !resp.data) {
							this.allLibraries = [];
							return;
						}

						this.allLibraries = resp.data;
						// Enable input and button after libraries are fetched successfully
						libraryInput.removeAttribute('disabled');
						submitButton.removeAttribute('disabled');
						this.initSelect();
					})
					.catch(() => {
						// Keep input and button disabled if fetch fails
						this.stepsObjects[1].error.querySelector('p').innerHTML = 'Failed to fetch libraries. Please try again later.';
						this.stepsObjects[1].error.classList.remove(this.classes.hidden);
					});
			}
		}
	}

	customElements.define('library-form', LibraryForm);
}

var ProductListLoadMore = class extends CustomHTMLElement {
	constructor() {
		super();
		this.productListInner = this.querySelector('.product-list__inner');
		this.productItems = Array.from(this.querySelectorAll('product-item'));
		this.mediaBreakpoint = parseInt(this.getAttribute('data-media-query'));

		this.isMobileSize = window.innerWidth < this.mediaBreakpoint;
		this.productsPerPage = parseInt(this.dataset.pagination);
		this.productsPerRow = this.isMobileSize ? parseInt(this.dataset.rowMobile) : parseInt(this.dataset.rowDesktop);
		this.nextUrl = document.getElementById('paginateNext');
		this.next_url = this.nextUrl ? this.nextUrl.dataset.nextUrl : false;
		this.collectionHandle = document.body.getAttribute('data-collection-handle');

		this.loadMoreBtn = document.querySelector('.load-more__btn');
		this.currentPage = 1;
		this.loadMoreProductsInitial = this.loadMoreProductsInitial.bind(this);
	}

	async connectedCallback() {
		if (this.nextUrl) {
			window.addEventListener('resize', this.debounce(this.setVariables.bind(this), 100));
			this.setVariables();

			this.loadMoreBtn.addEventListener('click', async (e) => {
				await this.loadMoreProducts();
			});

			if (document.querySelector('facet-filters')) {
				if (this.next_url === '') {
					this.loadMoreBtn.classList.add('is-hidden');
				} else {
					this.loadMoreBtn.classList.remove('is-hidden');
				}
			} else {
				if (this.productItems.length < this.productsPerRow) {
					this.classList.toggle('product-facet__product-list--loading');
					await this.initPopulate();
					this.classList.toggle('product-facet__product-list--loading');
				}
			}

			if (JSON.parse(localStorage.getItem('collectionLastVisibleProduct'))) {
				const collectionHistory = JSON.parse(localStorage.getItem('collectionLastVisibleProduct'));

				if (collectionHistory.collectionHandle != this.collectionHandle) {
					localStorage.removeItem('collectionLastVisibleProduct');
				}
			}

			window.addEventListener('beforeunload', () => {
				let visibleProductHandle = null;
				this.productItems.forEach((item) => {
					const rect = item.getBoundingClientRect();
					const isVisible =
						rect.top >= 0 &&
						rect.left >= 0 &&
						rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
						rect.right <= (window.innerWidth || document.documentElement.clientWidth);

					// If the product is visible in the viewport, store its ID or other relevant information
					if (isVisible && !visibleProductHandle) {
						// Assuming each product-item has an ID or a data attribute you can use (e.g., data-id="123")
						visibleProductHandle = item.getAttribute('data-handle');
					}
				});

				// Store the visible product ID in sessionStorage or localStorage for later use
				if (visibleProductHandle && this.collectionHandle) {
					localStorage.setItem(
						'collectionLastVisibleProduct',
						JSON.stringify({ collectionHandle: this.collectionHandle, productHandle: visibleProductHandle })
					);
				} else {
					localStorage.removeItem('collectionLastVisibleProduct');
				}
			});
		}
	}

	setVariables() {
		this.isMobileSize = window.innerWidth < this.mediaBreakpoint;
		this.productsPerRow = this.isMobileSize ? parseInt(this.dataset.rowMobile) : parseInt(this.dataset.rowDesktop);
	}

	debounce(fn, delay3) {
		let timer = null;
		return (...args) => {
			clearTimeout(timer);
			timer = setTimeout(() => {
				fn.apply(this, args);
			}, delay3);
		};
	}

	async getNextPage() {
		try {
			let res = await fetch(this.next_url);
			return await res.text();
		} catch (error) {
			console.log(error);
		}
	}

	async loadMoreProducts(initialLoad = false) {
		this.loadMoreBtn.setAttribute('aria-busy', 'true');
		let numberOfProductsRetrieved = 0;
		let productsRetrieved = Array.from(await this.fetchMoreProducts());

		numberOfProductsRetrieved = productsRetrieved.length;

		let moduloRows = numberOfProductsRetrieved % this.productsPerRow;
		let numberOfCompleteRows = Math.floor(numberOfProductsRetrieved / this.productsPerRow);

		let refetch = true;

		for (let i = 0; refetch == true; i++) {
			if (this.next_url !== '') {
				let additionalProducts = Array.from(await this.fetchMoreProducts());
				numberOfProductsRetrieved += additionalProducts.length;
				productsRetrieved = productsRetrieved.concat(additionalProducts);

				if (initialLoad && numberOfProductsRetrieved <= initialLoad) {
					refetch = false;
				} else {
					numberOfProductsRetrieved = productsRetrieved.length;
					numberOfCompleteRows = Math.floor(numberOfProductsRetrieved / this.productsPerRow);

					if (numberOfCompleteRows != 0 || this.next_url == '') {
						refetch = false;
					}
				}
			} else {
				refetch = false;
			}
		}

		if (this.currentPage != '') {
			const newUrl = new URL(window.location.href);
			const allParams = new URLSearchParams(newUrl.search);

			allParams.set('cp', this.currentPage);

			window.history.replaceState({}, '', `${newUrl.pathname}?${allParams}`);
		}

		for (let i = 0; i < productsRetrieved.length; i++) {
			this.productListInner.appendChild(productsRetrieved[i]);
		}

		if (this.productItems.length === Array.from(this.querySelectorAll('product-item')).length && this.next_url !== '') {
			this.productItems = Array.from(this.querySelectorAll('product-item'));
			await this.loadMoreProducts();
		} else {
			this.productItems = Array.from(this.querySelectorAll('product-item'));

			if (this.next_url === '') {
				this.loadMoreBtn.classList.add('is-hidden');
			} else {
				this.loadMoreBtn.removeAttribute('aria-busy');
			}
		}

		if (initialLoad) {
			this.checkScroll();
		}
	}

	async loadMoreProductsInitial(currentPage) {
		this.loadMoreBtn.setAttribute('aria-busy', 'true');
		let numberOfProductsRetrieved = 0;
		let productsRetrieved = [];

		let refetch = true;

		for (let i = 0; refetch == true && parseInt(this.currentPage) < currentPage; i++) {
			if (this.next_url !== '') {
				let additionalProducts = Array.from(await this.fetchMoreProducts());
				productsRetrieved = productsRetrieved.concat(additionalProducts);

				if (this.next_url == '') {
					refetch = false;
				}
			} else {
				refetch = false;
			}
		}

		if (this.currentPage <= currentPage) {
			const newUrl = new URL(window.location.href);
			const allParams = new URLSearchParams(newUrl.search);

			allParams.set('cp', this.currentPage);

			window.history.replaceState({}, '', `${newUrl.pathname}?${allParams}`);
		}

		for (let i = 0; i < productsRetrieved.length; i++) {
			this.productListInner = this.querySelector('.product-list__inner');
			this.productListInner.appendChild(productsRetrieved[i]);
		}

		this.productItems = Array.from(this.querySelectorAll('product-item'));

		if (this.next_url === '') {
			this.loadMoreBtn.classList.add('is-hidden');
		} else {
			this.loadMoreBtn.removeAttribute('aria-busy');
		}

		this.checkScroll();
	}

	async fetchMoreProducts() {
		let nextPage = await this.getNextPage();
		const searchParams = new URL(`${window.location.origin}${this.next_url}`).searchParams;
		const currentPage = searchParams.get('page');

		if (currentPage) {
			this.currentPage = currentPage;
		}

		const parser = new DOMParser();
		const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

		const productgrid = nextPageDoc.querySelector('.product-list__inner');
		const new_products = productgrid.getElementsByClassName('product-item');
		const newUrl = nextPageDoc.getElementById('paginateNext');

		const new_url = newUrl.dataset.nextUrl;

		if (new_url && new_url == '') {
			this.next_url = new_url;
			return;
		}
		this.next_url = new_url;

		return new_products;
	}

	async initPopulate() {
		const numberOfElements = this.productItems.length;
		const moduloRows = numberOfElements % this.productsPerRow;
		const numberOfCompleteRows = Math.floor(numberOfElements / this.productsPerRow);

		if (moduloRows > 0) {
			await this.loadMoreProducts(this.productPerRow - moduloRows);
		}
	}

	checkScroll() {
		const collectionHistory = JSON.parse(localStorage.getItem('collectionLastVisibleProduct'));

		if (collectionHistory) {
			if (collectionHistory.collectionHandle === this.collectionHandle) {
				const productToScrollTo = this.querySelector(`product-item[data-handle="${collectionHistory.productHandle}"]`);

				if (productToScrollTo) {
					const isInView = (elem) => {
						const bounding = elem.getBoundingClientRect();
						return bounding.top >= 0 && bounding.bottom <= window.innerHeight;
					};

					if (!isInView(productToScrollTo)) {
						productToScrollTo.scrollIntoView({ behavior: 'smooth' });
					}
				}
			} else {
				localStorage.removeItem('collectionLastVisibleProduct');
			}
		}
	}
};
__publicField(ProductListLoadMore, 'observedAttributes', ['hidden']);
window.customElements.define('product-list-load-more', ProductListLoadMore);
customElements.whenDefined('product-list-load-more').then(() => {
	const currentPageOnLoad = new URL(window.location.href).searchParams.get('cp');

	if (currentPageOnLoad) {
		document.dispatchEvent(
			new CustomEvent('product-list-load-more:load-initial-page', { detail: { currentPageOnLoad: parseInt(currentPageOnLoad) } })
		);
	}
});
